import { Button, Col, Row } from "react-bootstrap";
import EpaCard from "../../../../../leap-components/EpaCard";
import EpaField from "../../../../../leap-components/EpaField";
import { faHourglassEnd, faRssSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ICertificateOfRegistrationDetails } from "../../../../../api/CircularEconomy/CertificateOfRegistration/ICertificateOfRegistration";
import { formatDate } from "../../../../../api/DateUtils";
import {
  GetSubmissionUrl,
  GetRssUrl,
} from "../../../../../external-apps/Config";

var foreGroundColor = "#014891";
var backGroundColor = "#FFA500"; //Orange

interface CertificateDetailsProps {
  certificateOfRegistrationDetails: ICertificateOfRegistrationDetails;
}

const MakeASubmission = ({
  certificateOfRegistrationDetails,
}: CertificateDetailsProps) => {
  const isVisible =
    certificateOfRegistrationDetails.licence_status === "Applied";
  return (
    <div
      className="p-3"
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      <a
        href={GetSubmissionUrl(certificateOfRegistrationDetails.reg_no)}
        target="_blank"
        rel={certificateOfRegistrationDetails.reg_no}
        className="btn btn-primary"
      >
        <button>Make a Submission</button>
      </a>
    </div>
  );
};
const CertificateFields = ({
  certificateOfRegistrationDetails,
}: CertificateDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Registration Number"}
            value={certificateOfRegistrationDetails.reg_no}
          />
          <EpaField
            label={"Local Authority"}
            value={certificateOfRegistrationDetails.local_authority_org_name}
          />
          <EpaField
            label={"Application Date"}
            value={formatDate(
              certificateOfRegistrationDetails.valid_application_date
            )}
          />
          <EpaField
            label={"Status"}
            value={certificateOfRegistrationDetails.licence_status}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <MakeASubmission
            certificateOfRegistrationDetails={certificateOfRegistrationDetails}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Registration Details"} content={bodyElements} />;
};

export default CertificateFields;
